import axios from 'axios';
export default {
    get: async (url,params) => {
        const result = await axios.get(url, {params});
        return result.data;
    },

    post: async(url,data) => {
    const result = await axios.post(url,data);
    return result.data;
    }
}
